var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageContainer"},[_c('ps-lateral-bar',{staticClass:"lateralBar"}),_c('div',{staticClass:"dynamicRoute",attrs:{"id":"dynamicRoute"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }